

export interface UserNotificationsUpdate {
    userNotifications: UserNotification[],
    updateAdminAuctionGrid: boolean,
    updateAuctionGrid: boolean,
    updateOrderList: boolean,
    casesToUpdate: number[],
    appointmentsToUpdate: number[],
    ordersToUpdate: number[],
    activeAuctionsToUpdate: number[],
    myAuctionsToUpdate: number[]
}

export interface NotificationTranslation {
    fieldName: string;
    language: string; 
    name: string; 
}

export interface NotificationDetails {
    id: number;
    statusId: number;
    statusDisplayName: string;
    statusDate: Date;
    categoryDisplayName: string;
    vehiclePlateNumber: string;
    organizationOwnerName: string;
    caseNumber: string;
    caseId: number;
    userName: string;
    userHoName: string;
    text: string;
    translations: NotificationTranslation[];
}

export interface UserNotification {
    id: number;
    entityId: number;
    userId: string;
    title: string;
    subtitle: string;
    message: string;
    type: NotificationType,
    read: boolean;
    
    dateCreation: Date;

    detailsJson: string;
    details: NotificationDetails;
}

export enum NotificationType {
    Mavo,
    MavoAdmin,
    Supplier,
    SupplierRefresh,
    ActiveAuctionsRefresh, // this will be used when we want to refresh mavo data in Active Auctions grid in background without notifying user
    MyAuctionsRefresh, // this will be used when we want to refresh mavo data in My Auctions grid in background without notifying user


    Case = 10,
    
    Appointment = 20,
    
    Comment = 30

}